import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface Driver {
  id: number;
  fusionId: string;
  fullName: string;
  nationality: string;
  rtaPermitNo: string;
  permitExpiryDate: string;
  trafficCode: string;
  dob: string;
  mobileNo: string;
  eidNo: string;
  eidExpiryDate: string;
  drivingLicenseNo: string;
  dlExpiryDate: string;
}

interface DriverState {
  drivers: Driver[];
  searchTerm: string; // 🔍 Search field
}

const initialState: DriverState = {
  drivers: [],
  searchTerm: "", // 🔍 Default search term
};

const driverSlice = createSlice({
  name: "drivers",
  initialState,
  reducers: {
    addDriver: (state, action: PayloadAction<Driver>) => {
      state.drivers.push(action.payload);
    },
    setDriver: (state, action: PayloadAction<any>) => {
      // ✅ Removed pagination logic — always just set parsedData
      state.drivers = action.payload?.parsedData || [];
    },
    updateDriver: (state, action: PayloadAction<any>) => {
      state.drivers = action.payload?.parsedData;
    },
    removeDriver: (state, action: PayloadAction<number>) => {
      state.drivers = state.drivers.filter((d) => d.id !== action.payload);
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    clearReduxData: (state) => {
      state.drivers = [];
    },
  },
});

export const {
  addDriver,
  removeDriver,
  setSearchTerm,
  setDriver,
  clearReduxData,
  updateDriver,
} = driverSlice.actions;

export default driverSlice.reducer;
